var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.706 21.531"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.706 21.531H1a1 1 0 110-2h24.706a1 1 0 010 2zm0-10H1a1 1 0 010-2h24.706a1 1 0 010 2zm0-9.531H1a1 1 0 010-2h24.706a1 1 0 010 2z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYTZiNDA1ZTEtN2Y2My00NzRjLTliNTctMjA1NzM5ODI5YWU4IiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI2LjcwNiAyMS41MzEiPjxkZWZzPjxzdHlsZT4uYmQ1YzRiMTctYjU0NS00MTJhLWJiNDktNTEzNWY5ZGI4YTIwe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImJkNWM0YjE3LWI1NDUtNDEyYS1iYjQ5LTUxMzVmOWRiOGEyMCIgZD0iTTI2LjM1MywyMi4wMzFIMS42NDdhMSwxLDAsMSwxLDAtMkgyNi4zNTNhMSwxLDAsMCwxLDAsMlptMC0xMEgxLjY0N2ExLDEsMCwwLDEsMC0ySDI2LjM1M2ExLDEsMCwwLDEsMCwyWm0wLTkuNTMxSDEuNjQ3YTEsMSwwLDAsMSwwLTJIMjYuMzUzYTEsMSwwLDAsMSwwLDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC42NDcgLTAuNSkiLz48L3N2Zz4=";
export { SvgIconMore as ReactComponent };